import { fallback } from '@tanstack/zod-adapter';
import { z } from 'zod';

import { LIST_FILTERS } from '@/components/Investigations/types';
import { searchParam } from '@/utils/router';

// Stripped from URLs by the investigations layout route, so an unfiltered pane
// leaves no `?q=&status=Open` tail on every investigation link.
export const INVESTIGATIONS_SEARCH_DEFAULTS = { q: '', status: 'Open' } as const;

export const investigationsSearchSchema = z.object({
  q: searchParam().default(''),
  status: fallback(z.enum(LIST_FILTERS), 'Open').default('Open'),
});
